import { createXRStore } from "@react-three/xr";

/**
 * Singleton XR store for the entire app.
 *
 * Why a module-level singleton? `createXRStore` returns a Zustand store; we
 * need the same instance bound to the `<XR>` provider AND consumed by the
 * Enter-VR / Enter-AR buttons in the header (which live outside the Canvas).
 * Module-level keeps both halves in sync without prop drilling.
 *
 * Defaults are tuned for a "comfort first" presale experience:
 * - hand tracking on (Vision Pro thrives on it)
 * - controllers default ON for Quest 3 / WMR
 * - transient pointer (Vision Pro pinch / smartphone AR tap) on
 * - foveation 0.5 — balanced fidelity vs perf on Quest 3
 * - frame rate target 90 (Vision Pro auto-negotiates)
 */
export const xrStore = createXRStore({
  hand: { teleportPointer: true },
  controller: { teleportPointer: true },
  transientPointer: true,
  foveation: 0.5,
  frameRate: "high",
  // Comfort: vignette during locomotion is implemented in the locomotion
  // helper, not here. Snap-turn is enabled in the controller-locomotion hook.
  // Teleport pointer is in addition to smooth-walk locomotion — pmndrs/xr
  // routes it through the off-hand by default; user can teleport while
  // walking with the dominant hand. Required by ch.134 §6.1 dominance law.
});
